<template>
  <div :class="classes">
    <select
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="$emit('input', $refs.input.value)"
      ref="input"
    >
      <option v-for="(item, key) in options" :key="key" :value="key">
        {{ item }}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  name: "bx-select",
  props: {
    value: {
      default: ""
    },
    options: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data() {
    return {
      isPassword: false,
      passwordShow: false
    };
  },
  computed: {
    classes() {
      const classes = ["bx-select"];

      if (this.error) {
        classes.push("bx-select-error");
      }

      if (this.success) {
        classes.push("bx-select-success");
      }

      return classes;
    }
  }
};
</script>
